import React, { useState, useEffect } from 'react';
import { PortalCard, SVBPagination, SVBTypography } from '@svb/svb-react-components';
import Loading from '@svb/api-loading-component/dist/components/index';
import { slugCreator } from '../../../core/useStore';

export default function SVBFaqAllResult(props) {
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const postPerpage = 10;
  const indexOfLastPage = currentPage * postPerpage;
  const indexOfFirstPage = indexOfLastPage - postPerpage;
  const currentPost = props?.cardJson?.slice(indexOfFirstPage, indexOfLastPage);
  const totalPage = props?.cardJson?.length;
  const totalPerpage = Math.ceil(totalPage / postPerpage);
  const setPaginate = (pageNumber) => setCurrentPage(pageNumber);
  const sub_Heading_Faqs = 'All Questions';

  useEffect(() => {
    setLoading(false);
  }, []);

  return loading ? (
    <Loading />
  ) : (
    <>
      <div className='col-md-12 col-sm-12 pt-4'>
        <SVBTypography type='heading-large' variant='heading-medium'>
          {props.searchTerm.length === 0 ? sub_Heading_Faqs : `Result for : ${props.searchTerm}`}
        </SVBTypography>
      </div>
      {currentPost?.map((faqData, i) => {
        let faq_tags = [];
        faqData?.tags?.filter(
          (item) =>
            item.name !== 'common' &&
            item.value &&
            faq_tags.push({ label: item.value, type: 'svb-label_category-tag_type-faq' }),
        );
        return (
          <div
            className='col-md-6 col-sm-6 pt-4'
            role='button'
            key={i}
            data-testid={slugCreator(faqData?.title)}
          >
            <PortalCard
              data={{
                title: faqData.title,
                description: faqData.description,
                tags: faq_tags,
                action: {
                  type: 'card',
                  href: `/faqs/${slugCreator(faqData?.title)}`,
                },
              }}
            />
          </div>
        );
      })}
      <div className='pb-4 pt-4'>
        <SVBPagination
          totalPages={totalPerpage}
          currentPage={currentPage}
          setCurrentPage={setPaginate}
          extraClasses='d-flex justify-content-end'
        />
      </div>
    </>
  );
}
